/* tslint:disable:max-line-length */
/// <reference path='../../core/services/resource.service.ts'/>
/// <reference path='../../core/services/resource.service.ts'/>

namespace Search {
    class Tab {
        maxAge: number;
        multiRoomDisabled: boolean;
        constructor(
            public id: number,
            public type: UnifiedSearchType | null,
            public name: string,
            options?
        ){
            angular.extend(this, options);
        }
    }

    class Search {
        tab: Tab;
        tabs:any = {
            1: new Tab(1, UnifiedSearchType.Holidays, 'holidays', { maxAge: TRPCONFIG.Domain.MaxChildAgeForHolidays }),
            2: new Tab(2, UnifiedSearchType.Hotels, 'hotels'),
            3: new Tab(3, UnifiedSearchType.Flights, 'flights', { maxAge: TRPCONFIG.Domain.MaxChildAgeForFlights, multiRoomDisabled: true }),
            4: new Tab(4, null, 'transfers', ''),
            5: new Tab(5, null, 'cruises', ''),
            6: new Tab(6, null, 'marhaba', ''),
            7: new Tab(7, null, 'holidayDeals', ''),
            8: new Tab(8, null, 'insurance', '')
        };
        model: UnifiedSearchModel;
        allowNoDatesYet = true;
        overrideAllowNoDatesYet;
        currencyOptions = TRPCONFIG.Domain.CurrencyOptions.split('|');
        cabins;
        userSession: any = sessionStorage.getItem('scope.user');
        bookingRef: any = this.bookingInfo(this.userSession);
        enabledDates;
        preselectTab: string;
        showTabs: boolean;
        includedTabIds: number[];
        supportedTabIds: any;
        fid: string;
        clearFormInAgentMode: string;
        hiddenQueryString: string;
        airlines: Airline[];
        expandedOptions = false;
        trackDefaultParameters: string;
        isFlexibleTripType: boolean;
        disableResetOptions;
        searchOpened = false;
        isSearching = false;

        constructor (
            private $route: ng.route.IRouteService,
            private $q: ng.IQService,
            private broker: Core.Broker,
            private searchUnitService: SearchUnitService,
            private holidayStartDateGuardService: HolidayStartDateGuardService,
            private unifiedSearchService: UnifiedSearchService,
            private $scope,
            private destinationService,
            private searchQueryString: SearchQueryString,
            private $timeout: ng.ITimeoutService,
            private preferences,
            private $locale: any
        ) {
            if (TRPCONFIG.Domain.PassThroughSearchToIntegratedSearch) {
                return;
            }

            this.checksigninstatus();

            this.model = this.unifiedSearchService.getDefaultModel();
            this.cabins = searchUnitService.getCabinOptions();

            this.updateNoDatesYet();
            this.airlines = searchQueryString.allAirlines;

            this.supportedTabIds = _.chain(TRPCONFIG.Domain.SupportedProductNames)
                .map(name => this.findTabId(name))
                .filter(tabId => !!tabId)
                .value();

            let intersection =
                this.includedTabIds ? _.intersection(this.supportedTabIds, this.includedTabIds) : this.supportedTabIds;
            this.showTabs = intersection.length > 1;

            let tabIdToSelect = this.getPreselectTabId();

            this.selectTab(tabIdToSelect);

            const clearForm = TRPCONFIG.Domain.isAgentMode && this.clearFormInAgentMode === 'true';
            if (!clearForm) {
                this.unifiedSearchService.getQueryStringValues(this.hiddenQueryString).then(queryStringValues => {
                    this.unifiedSearchService
                        .prepopulateModel(this.model, queryStringValues);

                    this.expandedOptions = (() => {
                        if (!angular.isUndefined(queryStringValues.expandedOptions)) {
                            return queryStringValues.expandedOptions;
                        }
                        if (TRPCONFIG.Domain.PrefilterAirlineEnabled && this.model.airlines && this.model.airlines.length) {
                            return true;
                        }
                        if (TRPCONFIG.Domain.PrefilterDirectFlightsEnabled && this.model.prefilterDirectFlights) {
                            return true;
                        }
                        return false;
                    })();

                    if (queryStringValues.autoSearch) {
                        if ( queryStringValues.sortOrder ) {
                            this.preferences.setHotelSortOrder( parseInt(queryStringValues.sortOrder,10) );
                        }
                        this.$timeout(() => this.search(true), 1000);
                    }
                });
            }

            this.$scope.$watchCollection(() => this.model.destination, val => {
                //Ensure that destination is always an array.
                if (val && angular.isUndefined(val.length)) {
                    val = this.model.destination = [val];
                }

                if (val && val[0]) {
                    //This call mutates the destination:
                    this.destinationService.getDetails(val[0]).then(dest => {
                        broker.publish('destinationChanged', dest);
                        this.loadOutboundDates(this.model.airports, dest);
                    });
                }
                let searchLookupType = val && val[0] && val[0].searchLookupType;
                this.updateNoDatesYet(searchLookupType);
            });

            this.$scope.$watchCollection(() => this.model.airports,
                val => this.loadOutboundDates(val, this.model.destination));

            if(!_.isEmpty(TRPCONFIG.Domain.FixedDepartureAirportOptions)) {
                this.broker.subscribe('holidaySearch', 'departureAirportsChanged', (v) => {

                    let currentAirports = this.model.airports.reduce((acc, airport) => {
                        return acc[airport.Code] = airport;
                    }, {});
                    let updatedAirports = v.data.Code.split(',').map(code => currentAirports[code] || ({Code: code}));
                    this.model.airports = updatedAirports;
                });
            }

            this.broker.subscribe('holidaySearch', 'RegionalContextSelected', () => {
                //reset the preferences when switching between POS
                this.model.airports = [];
                this.unifiedSearchService.saveSearchModel(this.model);
            });
        };

        checksigninstatus(): any {
            let user = sessionStorage.getItem('scope.user');
            if (!user) {
                (document.querySelector('.myb-search-signout') as HTMLInputElement).style.display = 'none';
                (document.querySelector('.myb-search-signin') as HTMLInputElement).style.display = 'block';
            } else {
                (document.querySelector('.myb-search-signout') as HTMLInputElement).style.display = 'block';
                (document.querySelector('.myb-search-signin') as HTMLInputElement).style.display = 'none';
            }
        }

        bookingInfo(session): any {
            session = JSON.parse(session);
            if (session) {
                return session.BookingSummary.BookingRef;
            }
        }

        selectTab(tabId: number): void {
            this.$scope.$broadcast('flash:hide');
            this.tab = this.tabs[tabId];
            if(this.$route.current && this.$route.current['$$route']) {
                this.$route.current['$$route'].area = this.tab.name;
            }
            this.loadOutboundDates(this.model.airports, this.model.destination);
        };

        includeTab(tabId: number): boolean {
            const isIncluded = !this.includedTabIds || !this.includedTabIds.length || this.includedTabIds.indexOf(tabId) >= 0,
                isSupported = !this.supportedTabIds || !this.supportedTabIds.length || this.supportedTabIds.indexOf(tabId) >= 0;
            return isIncluded && isSupported;
        }

        private getPreselectTabId(): number {
            let tabId = this.findTabId(this.preselectTab);
            if (tabId && this.includeTab(tabId)) {
                return tabId;
            }
            return _.find(this.tabs, (t:Tab) => this.includeTab(t.id)).id;
        }

        private findTabId(tabNameOrNumber: string): number | undefined {
            if (!tabNameOrNumber) {
                return;
            }
            let tabId = parseInt(tabNameOrNumber, 10);
            if (tabId > 0 && this.tabs[tabId]) {
                return tabId;
            }
            tabNameOrNumber = (tabNameOrNumber + '').toLowerCase();
            let tab = _.find(this.tabs, (t: any) => t.name.toLowerCase() === tabNameOrNumber);
            if (tab) {
                return tab.id;
            }
        }

        private updateNoDatesYet(searchLookupType?: string) {
            if (this.overrideAllowNoDatesYet) {
                this.allowNoDatesYet = this.overrideAllowNoDatesYet === 'true';
            } else {
                this.allowNoDatesYet = !searchLookupType || searchLookupType === 'hotels';
            }
            if (!this.allowNoDatesYet) {
                this.model.noDatesYet = false;
            }
        }

        private canUseSelectedHolidayStartDate(): boolean {
            if (this.tab.type !== UnifiedSearchType.Holidays) {
                return true;
            }

            if (!this.holidayStartDateGuardService.canUseHolidayStartDate(this.model.startDate)) {
                return false;
            }

            const selectedDateKey = this.holidayStartDateGuardService.getDateKey(this.model.startDate);
            const hasEnabledDates = this.enabledDates && Object.keys(this.enabledDates).length > 0;

            if (hasEnabledDates && !this.enabledDates[selectedDateKey]) {
                return false;
            }

            return true;
        }

        checkScreensize() {
            let searchPanel = document.querySelectorAll('.ekh-search-panel')[0];
            let mybPanel = document.querySelectorAll('.ekh-myb-panel')[0];
            if (window.innerWidth <= 880 && this.searchOpened === false) {
                searchPanel.classList.add('panel-hide');
                mybPanel.classList.add('panel-hide');
            } else {
                searchPanel.classList.remove('panel-hide');
                mybPanel.classList.add('panel-hide');
            }
        }

        arrowPressCheck() {
            window.addEventListener('keydown', e => {
                if (e.target instanceof HTMLElement) {
                    const cl = e.target.classList;
                    let classes: any = cl;
                    if (classes.contains('bookingNumber') &&
                        (e.key === 'ArrowUp' || e.key === 'ArrowDown')) {
                        e.preventDefault();
                    }
                }
            });
        }

        displaySearch() {
            let isMobile = TRPCONFIG.IsMobileView;

            if(!isMobile) {
                let t = this;
                window.addEventListener('resize', function(){
                    t.checkScreensize();
                });
            }

            this.checkScreensize();
        }

        displaySearchPanel() {
            let searchPanel = document.querySelectorAll('.ekh-search-panel')[0];
            let mybPanel = document.querySelectorAll('.ekh-myb-panel')[0];
            searchPanel.classList.remove('panel-hide');
            mybPanel.classList.add('panel-hide');
        }

        toggleSearch() {
            this.searchOpened = this.searchOpened ? false : true;
            let searchClasses = document.querySelectorAll('.ekh-search-panel')[0].classList;
            searchClasses.toggle('panel-hide');
        }

        convertDateToISO(date, shortMonth) {
            let d = date.split('-');
            let month;
            shortMonth.map((v, i) => {
                if (d[1] === v) {
                    let m = i+1;
                    if (m < 10) {
                        month = `0${m}`;
                    } else {
                        month = m.toString();
                    }
                }
            });
            let convertedDate = `${d[2]}-${month}-${d[0]}T00:00:00.000Z`;
            return convertedDate;
        }

        search(isAutoSearch: boolean) {
            /*
             * Search resolution and navigation are asynchronous enough that the user
             * can submit the same search repeatedly before the next page is displayed.
             *
             * Set the guard synchronously so only the first invocation can progress.
             * The same state is exposed to the template for disabled/loading feedback.
             */
            if (this.isSearching) {
                return this.$q.when();
            }

            sessionStorage.removeItem('FlightMiles');
            sessionStorage.removeItem('baseCost');
            sessionStorage.removeItem('flightFare');
            sessionStorage.removeItem('SkywardsMiles');
            sessionStorage.removeItem('SkywardsMilesFlights');
            sessionStorage.removeItem('FlightPerPersonMiles');
            sessionStorage.removeItem('BrandedFareDetailsSessionId');
            sessionStorage.removeItem('chargeDates');
            sessionStorage.removeItem('PaymentPopup');
            TRPCONFIG.Domain.FlightMiles = '';
            TRPCONFIG.Domain.SkywardsInfo = '';
            TRPCONFIG.Domain.SkywardsFlightMiles = '';
            TRPCONFIG.Domain.BrandedFareCancellations = '';
            TRPCONFIG.Domain.CancellationData = '';
            TRPCONFIG.Domain.TransferPrice = 0;

            let start = (document.getElementsByClassName('searchDates')[0] as HTMLInputElement).value;
            let end = (document.getElementsByClassName('searchDates')[1] as HTMLInputElement).value;
            let searchData = {
                ISOstartDate: start ? this.convertDateToISO(start, this.$locale.DATETIME_FORMATS.SHORTMONTH) : '',
                ISOendDate: end ? this.convertDateToISO(end, this.$locale.DATETIME_FORMATS.SHORTMONTH) : '',
                startDate: start,
                endDate: end
            };

            sessionStorage.setItem('searchDates', JSON.stringify(searchData));

            this.isSearching = true;

            return this.destinationService
                .getDetails(this.model.destination[0])
                .then(dest => {
                    return this.loadOutboundDates(this.model.airports, dest)
                        .then(() => dest);
                })
                .then(dest => {
                    if (!this.canUseSelectedHolidayStartDate()) {
                        /*
                         * A restored/pre-populated holiday departure date can become invalid
                         * after the configured minimum departure date moves on.
                         *
                         * The calendar prevents a fresh invalid selection, but this submit path
                         * can still be reached with stale search state. Revalidate immediately
                         * before launchSearch so the booking flow cannot continue with an
                         * out-of-date departure.
                         *
                         * This legacy search unit stores date state in more than one place.
                         * Clearing model.startDate/model.endDate alone does not clear the
                         * rendered date inputs, because this path also reads those inputs
                         * directly via document.getElementsByClassName('searchDates').
                         *
                         * Clear all known local representations so the rejected stale date is
                         * not left visible or re-used on the next search attempt.
                         */
                        this.model.startDate = '';
                        this.model.endDate = '';

                        const startInput =
                            document.getElementsByClassName('searchDates')[0] as HTMLInputElement;
                        const endInput =
                            document.getElementsByClassName('searchDates')[1] as HTMLInputElement;

                        if (startInput) {
                            startInput.value = '';
                        }

                        if (endInput) {
                            endInput.value = '';
                        }

                        sessionStorage.removeItem('searchDates');
                        this.unifiedSearchService.saveSearchModel(this.model);

                        /*
                         * Navigation was deliberately abandoned, so allow the corrected
                         * search form to be submitted again.
                         */
                        this.isSearching = false;

                        return;
                    }

                    //creating a copy of the model to use to run a search.
                    const destination = _.assign({}, this.model.destination[0], dest);
                    const model = <UnifiedSearchModel>_.assign(
                        <UnifiedSearchModel>{},
                        this.model,
                        { destination: [destination] }
                    );

                    /*
                     * Keep isSearching true while the workflow validates and starts navigation.
                     * Validation or workflow failures propagate back through the returned promise
                     * and are handled by the catch below. Successful navigation destroys this
                     * directive, so there is no success-path reset.
                     */
                    return this.unifiedSearchService.launchSearch(
                        model,
                        this.tab.type || UnifiedSearchType.Holidays,
                        this.fid,
                        !isAutoSearch,
                        false,
                        false
                    );
                })
                .catch(errors => {
                    /*
                     * Destination/date resolution, workflow validation or search startup failed.
                     * Restore the form so the user can correct the search and retry.
                     */
                    this.isSearching = false;
                    return this.$q.reject(errors);
                });
        };

        loadOutboundDates(airports, destination) {
            const getRequest = () => {
                if (this.tab.id !== 1 && this.tab.id !== 3) {
                    return this.$q.when(null);
                }

                if (!airports || !airports.length) {
                    return this.$q.when(null);
                }

                let DepartureAirportCodes = _.map(airports, (a: any) => a.Code);

                destination = destination && destination[0] || destination;
                let codes = destination && (destination.Code || destination.DestinationAirports);
                let DestinationAirportCodes = codes && codes.split(',');

                if (DestinationAirportCodes && DestinationAirportCodes.length) {
                    return this.$q.when({
                        DepartureAirportCodes,
                        DestinationAirportCodes
                    });
                }

                return this.$q.when(null);
            };

            return getRequest()
                .then(r => this.searchUnitService.loadOutboundDates(r))
                .then(outboundDates => {
                    this.enabledDates = outboundDates;
                });
        }
    }

    angular
        .module('search')
        .directive('search', (): ng.IDirective => {
            return {
                scope: {},
                controller: Search,
                controllerAs: 'search',
                bindToController: {
                    moreOptions: '=',
                    preselectTab: '@',
                    overrideAllowNoDatesYet: '@',
                    includedTabIds: '=?',
                    fid: '=?',
                    clearFormInAgentMode: '@',
                    hiddenQueryString: '@',
                    trackDefaultParameters: '@',
                    resetDuration: '=?',
                    isFlexibleTripType: '=?',
                    disableResetOptions: '@?'
                },
                templateUrl: TRPCONFIG.Domain.PassThroughSearchToIntegratedSearch
                    || new RegExp(/[a-z]{3,4}:[a-z]{3,4}/g).test(TRPCONFIG.Domain.RedirectTemplates)
                    ? 'partials/search/integrated'
                    : 'partials/search/search',
                replace: true,
                restrict: 'E',
            };
        });
}
